import { createCapabilityBus } from '@platform-ui/remote-utils';

const { bus } = createCapabilityBus({ devTools: import.meta.env.DEV });

/** Singleton capability bus instance shared across the portal host. */
export const capabilityBus = bus;
